<div class="modal-body KhModal">
    <h3 class="modal-h3" [innerHTML]="title | unsafeHtml"></h3>
    <div [innerHTML]="body | unsafeHtml" class="spacer-md"></div>

    <div class="center KhModalButtons">
        <button class="btn btn-primary btn1" (click)="button1Click()" *ngIf="button1Text" [innerHTML]="button1Text | unsafeHtml" style=""></button>
        <button class="btn btn-default" (click)="button2Click()" [innerHTML]="button2Text | unsafeHtml" *ngIf="button2Text"></button>
    </div>
</div>
